import { Injectable, inject } from '@angular/core';
import { EntityCrudService } from '@data/entity-crud.service';
import { HttpClient } from '@angular/common/http';
import { MatchingSession } from '@data/matching-session/matching-session.model';

@Injectable({
  providedIn: 'root',
})
export class MatchingSessionService extends EntityCrudService<MatchingSession, MatchingSession> {
  constructor() {
    const http = inject(HttpClient);

    super('matching-sessions', http);
  }
}
